module.exports = __webpack_public_path__ + "static/media/coffee_phone.981d467f.png";